import { Component } from '@angular/core';
import SwiperCore, { Autoplay, Navigation, Pagination, SwiperOptions } from 'swiper';

SwiperCore.use([Navigation, Pagination, Autoplay])


@Component({
  selector: 'swiper-employer',
  templateUrl: './swiper-employer.component.html',
  styleUrls: ['./swiper-employer.component.css']
})
export class SwiperEmployerComponent {

  public swiperConfig: SwiperOptions = {
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 450,
    autoplay: true,
    grabCursor: true,
    loop: true,
    preloadImages: false,
    lazy: true,
    pagination: {
      el: '#swiper-employer-list',
      clickable: true,
    },
    navigation: {
      nextEl: '#swiper-employer-list-next',
      prevEl: '#swiper-employer-list-prev',
    },
    breakpoints: {
      576: {
        slidesPerView: 2
      },
      768: {
        slidesPerView: 3
      },
      992: {
        slidesPerView: 4
      },
      1280: {
        slidesPerView: 5
      }
    }
  }



  constructor() { }
}
